export default function getCampaignStatusLabel(campaignStatus, Vue) {
    if (Vue.$te('statuses.campaign.' + campaignStatus, Vue.$i18n.locale)) {
        return Vue.$t('statuses.campaign.' + campaignStatus)
    }

    return Vue.$t('unknown');
}